import authFetch from './fetch';
import { makeRequest, getQueryParams } from './utils';

const PLATE_TYPES_PATH = '/api/PlateType';

export const getPlateTypesGrid = (params) => makeRequest(authFetch.get(`${PLATE_TYPES_PATH}${getQueryParams(params)}`))
  .then(({ data, ...rest }) => ({
    ...rest,
    data: data.map((item) => ({
      ...item,
      plateTypeStates: item.plateTypeStates
        .map(({ stateName, gracePeriod }) => `${stateName}: ${gracePeriod}`).join(', '),
    })),
  }));

export const exportPlateTypes = (params) => {
  const requestParams = {
    ...params,
    page: 1,
    pageSize: 9999,
  };

  return getPlateTypesGrid(requestParams).then(({ data }) => data);
};

// Details
export const getPlateTypeById = (plateTypeId) => makeRequest(authFetch.get(`${PLATE_TYPES_PATH}/${plateTypeId}`));

export const savePlateType = (data) => makeRequest(authFetch.put(PLATE_TYPES_PATH, data));

export const deletePlateTypeById = (plateTypeId) => makeRequest(authFetch.delete(`${PLATE_TYPES_PATH}/${plateTypeId}`));

export const restorePlateTypeById = (plateTypeId) => makeRequest(
  authFetch.patch(`${PLATE_TYPES_PATH}/${plateTypeId}/restore`),
);

// Audit
export const getPlateTypeAudits = (plateTypeId, params) => makeRequest(
  authFetch.get(`${PLATE_TYPES_PATH}/${plateTypeId}/Audits${getQueryParams(params)}`),
);

export const getPlateTypeAuditProperties = (plateTypeId) => makeRequest(
  authFetch.get(`${PLATE_TYPES_PATH}/${plateTypeId}/Audits/Properties`),
);

export const getPlateTypeAuditUsers = (plateTypeId) => makeRequest(
  authFetch.get(`${PLATE_TYPES_PATH}/${plateTypeId}/Audits/Users`),
);

// Lookups
export const getAllPlateTypes = () => makeRequest(authFetch.get(`${PLATE_TYPES_PATH}/all`));

export const getPlateTypesLookup = () => makeRequest(authFetch.get(`${PLATE_TYPES_PATH}/lookup`));